import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SharedUiPersonaEligibilityModule } from '@se-po/shared-ui-persona-eligibility'
import { SharedUiProfileSidePanelModule } from '@se-po/shared-ui-profile-side-panel'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeSidePanelModule } from 'se-fe-side-panel'
import { PersonaEligibilitySidePanelComponent } from './persona-eligibility-side-panel/persona-eligibility-side-panel.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeSidePanelModule,
    SharedUiPersonaEligibilityModule,
    SharedUiProfileSidePanelModule
  ],
  declarations: [
    PersonaEligibilitySidePanelComponent
  ],
  exports: [
    PersonaEligibilitySidePanelComponent
  ]
})
export class SeMySportsengineUiPersonaEligibilitySidePanelModule {}
